import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './constants';


export function* watchForMediaGeneration() {
    yield takeLatest(types.MEDIA_GENERATION_REQUEST, mediaGenerationApi);
}

export function* mediaGenerationApi(action) {

    try {
        const result = yield call(action.mediaGenerationApi, action.payload);
        if (result?.imageUrls) {
            yield put({
                type: types.MEDIA_GENERATION_SUCCESS,
                data: result?.imageUrls,
            });
        } else {
            yield put({
                type: types.MEDIA_GENERATION_FAILURE,
                data: result,
            });
        }
    } catch (error) {
        yield put({
            type: types.MEDIA_GENERATION_FAILURE,
            data: error,
        });
    }
}

export default [watchForMediaGeneration];